import { Card, InfoRow, StatusBadge, ModeBadge } from './BmsCardPrimitives'

const IndicatorsCard = ({ bms, className = '' }) => (
  <Card className={className}>
    <InfoRow label="Charge MOSFET" value={<StatusBadge on={bms.chargeMosfet} />} />
    <InfoRow label="Discharge MOSFET" value={<StatusBadge on={bms.dischargeMosfet} />} />
    <InfoRow label="Precharge MOSFET" value={<StatusBadge on={bms.prechargeMosfet} />} />
    <InfoRow label="Power mode" value={<ModeBadge on={bms.powerMode} />} />
    <InfoRow label="Battery mode" value={<ModeBadge on={bms.batteryMode} />} />
  </Card>
)

export default IndicatorsCard
